import React from 'react'; // eslint-disable-line
import { Link } from 'react-router-dom';

const MenuItem = (props) => {
    return (
        <li
            data-qa={`menu-item-for-${props.name}`}
            className={`${props.className} ${props.currentMenuItem === props.moduleName ? 'current' : ''}`}
        >
            <Link to={{
                pathname: `${props.baseVersionLink}/${props.link}`,
                state: props.menuIsHidden,
            }}
            >
                {props.name}
            </Link>
        </li>
    );
};

export default MenuItem;
